import React from 'react';
import { publicRuntimeConfig } from '../../../config';
import { withNavigation } from '../../../hoc';
import { sendAdfsLogin } from '../../../utils/adfsLogin';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Button } from '../../common';

const LoginForm = ({ navigate, ...props }) => {
    const isProd = publicRuntimeConfig.settings.isProd;
    const CommonButton = props => <Button {...props} minWidth='150px' maxWidth='185px' style={{ margin: '5px' }} />;

    return (
        <FlexContainer justify={isProd ? 'center' : 'space-between'}>
            {!isProd && <CommonButton text='BACKOFFICE' onClick={() => navigate('/login')} />}
            <CommonButton text={isProd ? 'Ingresar' : 'ADFS'} onClick={() => sendAdfsLogin()} />
        </FlexContainer>
    );
};

export default withNavigation(LoginForm);
